import React  from "react";
import {
  Row,
  Col,
  ListGroupItem,
  Panel,
  ListGroup
} from "react-bootstrap";
import Ticks from "../Ticks/";
import moment from "moment";

import "./styles.css";

export default props => {
  

  const { outboundData, inboundData } = props;
  const ifInbound = inboundData ? 6 : 12;
  let timeLabelOut;
  let numberLabelOut;
  let hasNumberOut;
  let timeLabelIn;
  let numberLabelIn;
  let hasNumberIn;

  //check if it's flight train or other
  if (outboundData) {
    if (
      outboundData.flightTimeOverride ||
      outboundData.flightNumberLabel === "Do not complete"
    ) {
      timeLabelOut = "Pick Up Time";
      numberLabelOut = "No.";
      hasNumberOut = false;
    } else {
      switch (outboundData.flightNumberLabel) {
        case "Train number":
          timeLabelOut = "Train Time";
          numberLabelOut = "Train No.";
          hasNumberOut = true;
          break;
        case "Flight number":
          timeLabelOut = "Flight Time";
          numberLabelOut = "Flight No.";
          hasNumberOut = true;
          break;
        default:
          timeLabelOut = "Pick Up Time";
          numberLabelOut = "No.";
          hasNumberOut = false;
      }
    }
  }

  if (inboundData) {
    if (
      inboundData.flightTimeOverride  ||
      inboundData.flightNumberLabel === "Do not complete"
    ) {
      timeLabelIn = "Pick Up Time";
      numberLabelIn = "No.";
      hasNumberIn = false;
    } else {
      switch (inboundData.flightNumberLabel) {
        case "Train number":
          timeLabelIn = "Train Time";
          numberLabelIn = "Train No.";
          hasNumberIn = true;
          break;
        case "Flight number":
          timeLabelIn = "Flight Time";
          numberLabelIn = "Flight No.";
          hasNumberIn = true;
          break;
        default:
          timeLabelIn = "Pick Up Time";
          numberLabelIn = "No.";
          hasNumberIn = false;
      }
    }
  }
  
  return (
    window.history.replaceState(
      null,
      "Airport Transfers to Ski Resorts | Ski-Lifts",
      "/confirm"
    ),
    (
      <div>
        <Col>
          <Panel>
            <Panel.Heading>
              <Panel.Title className="panel-title">
          <h3  className="centered">Your Travel Details</h3>
      </Panel.Title>

            </Panel.Heading>
            <Panel.Body>
          <div className="change-options">
              <a href="/quote/return" className="btn btn-success"><span>Change my options</span></a>
          </div>
              <Col xs={12} md={ifInbound} className="text-center">
                <Panel
                  className="outbound-panel"
                  style={{
                    margin: ifInbound ? "0 auto" : "inherit"
                  }}
                >
                  <Panel.Heading>
                    <h4>
                      <strong>Outbound Transfer</strong>
                    </h4>
                  </Panel.Heading>
                  <ListGroup fill>
                    <ListGroupItem className='main-list-item' >
                   
                    <span> {outboundData.fromDestination.name}</span>
                       
                    <div className="fromTo" >&gt;</div>
                   
                          <span> {outboundData.toDestination.name}</span>
                      
                   
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Departing Date</Col>
                        <Col xs={6}>
                          {moment(outboundData.date).format("Do MMMM YYYY")}
                        </Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>{timeLabelOut}</Col>
                        <Col xs={6}>{outboundData.time}</Col>
                      </Row>
                    </ListGroupItem>
                    {hasNumberOut && (
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>{numberLabelOut}</Col>
                          <Col xs={6}>{outboundData.flightNumber}</Col>
                        </Row>
                      </ListGroupItem>
                    )}
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Adults</Col>
                        <Col xs={6}>{outboundData.adults}</Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Children</Col>
                        <Col xs={6}>{outboundData.children.length}</Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Skis/snowboards</Col>
                        <Col xs={6}>{outboundData.numberOfSkis}</Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Bikes / Golf Bags</Col>
                        <Col xs={6}>{outboundData.numberOfBikes}</Col>
                      </Row>
                    </ListGroupItem>
                    <ListGroupItem>
                      <Row>
                        <Col xs={6}>Items of Hold Luggage</Col>
                        <Col xs={6}>{outboundData.numberOfHoldItems}</Col>
                      </Row>
                    </ListGroupItem>
                  </ListGroup>
                  <Col className="ticks">
                    <Ticks
                      inboundData={inboundData}
                      options={props.options}
                      journeyType="outbound"
                    />
                  </Col>
                </Panel>
              </Col>
              {inboundData ? (
                <Col xs={12} md={6} className="text-center">
                  <Panel
                    className="inbound-panel"
                  >
                    <Panel.Heading>
                      <h4>
                        <strong>Return Transfer</strong>
                      </h4>
                    </Panel.Heading>
                    <ListGroup >
                      <ListGroupItem  className='main-list-item' >
                   
                   <span> {inboundData.fromDestination.name}</span>
                      
                         <div className="fromTo" >&gt;</div>
                  
                         <span> {inboundData.toDestination.name}</span>
                     
                  
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Departing Date</Col>
                          <Col xs={6}>
                            {moment(inboundData.date).format("Do MMMM YYYY")}
                          </Col>
                        </Row>
                      </ListGroupItem>

                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>{timeLabelIn}</Col>
                          <Col xs={6}>{inboundData.time}</Col>
                        </Row>
                      </ListGroupItem>
                      {hasNumberIn && (
                        <ListGroupItem>
                          <Row>
                            <Col xs={6}>{numberLabelIn}</Col>
                            <Col xs={6}>{inboundData.flightNumber}</Col>
                          </Row>
                        </ListGroupItem>
                      )}
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Adults</Col>
                          <Col xs={6}>{inboundData.adults}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Children</Col>
                          <Col xs={6}>{inboundData.children.length}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Skis/snowboards</Col>
                          <Col xs={6}>{inboundData.numberOfSkis}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Bikes / Golf Bags</Col>
                          <Col xs={6}>{inboundData.numberOfBikes}</Col>
                        </Row>
                      </ListGroupItem>
                      <ListGroupItem>
                        <Row>
                          <Col xs={6}>Items of Hold Luggage</Col>
                          <Col xs={6}>{inboundData.numberOfHoldItems}</Col>
                        </Row>
                      </ListGroupItem>
                    </ListGroup>
                    <Col className="ticks">
                      <Ticks
                        inboundData={inboundData}
                        options={props.options}
                        journeyType="inbound"
                      />
                    </Col>
                  </Panel>
                </Col>
              ) : null}
            </Panel.Body>
          </Panel>

        </Col>
      </div>
    )
  );
};



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage/PersonalDetails/index.js